// extracted by mini-css-extract-plugin
export default {"root":"_34KjsxEs","container":"agaDhVdK","html":"_32RBVo5D"};